/* TODO: t() */
import React from 'react';
import FormView from './HeadingElement/HeadingElementFormView';
import FieldEditor from './HeadingElement/HeadingElementFieldEditorView';

import FormElementBase from '../FormElementBase';
import { Icon } from '../../uiold';
import { FormFieldDefinition } from '../../../types/shared/FormFieldDefinition';

class HeadingElement extends FormElementBase {
  static getType() {
    return 'HeadingElement';
  }

  static getDescription() {
    return 'Section Heading';
  }

  static getAttributes() {
    return {
      text: 'Section Heading',
    };
  }

  static getIconName() {
    return 'heading';
  }
  static getIcon() {
    return <Icon name="heading" size="M" />;
  }

  renderFieldEditor() {
    return <FieldEditor key={this.id} ref="field-editor" parent={this} />;
  }

  renderFieldView() {
    return (
      <FormView
        key={this.id}
        ref={this.id}
        definition={this.definition as FormFieldDefinition}
      />
    );
  }

  renderFormView() {
    return (
      <FormView
        key={this.id}
        ref={this.id}
        definition={this.definition as FormFieldDefinition}
      />
    );
  }

  renderReadOnlyView() {
    return null;
  }

  renderEditView() {
    return null;
  }
}

export default HeadingElement;
